import React from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

import { uiActions } from "../store/ui/ui-slice";
import { getAxios } from "../shared/Services/commonService";
import { API_DASHBOARD_COUNT } from "../utils/api/ApiConstant";
import { SubHeading } from "../shared/Components";

const Dashboard = () => {
  const location = useLocation();
  const { heading } = location.state || {};
  const dispatch = useDispatch();

  if (heading) {
    dispatch(uiActions.setHeading(heading));
  }

  const { isLoading, data: dashboardCount } = useQuery({
    queryKey: ["dashboardCountData"],
    queryFn: async () => await getAxios(API_DASHBOARD_COUNT, {}),
  });

  return (
    <>
      <SubHeading subTitle="Today Matches Data" isAddBtn={false} />
      <div className="row">
        <div className="col-lg-6">
          <div className="box_book ">
            <p className="text_titan">Today Bookmaker</p>
            <h5 className="text_desc font-green">
              {dashboardCount?.bookmakerCount}
            </h5>
          </div>
        </div>
        <div className="col-lg-6 ">
          <div className=" box_book">
            <p className="text_titan">Today Fancy</p>
            <h5 className="text_desc font-green">
              {dashboardCount?.fancyCount}
            </h5>
          </div>
        </div>
      </div>

      <div className="row ">
        <div className="col-md-6 col-lg-4 ">
          <div className="card_desmond ">
            <div className="card-header ">
              <h4 className="card-title">Cricket</h4>
            </div>

            <div className="table-responsive ">
              <table className="report-card-box">
                <tbody>
                  {dashboardCount?.matches
                    ?.filter((item) => item?.sport?.id == 4)
                    ?.map((item) => (
                      <tr key={item?._id} className="">
                        <td className="text-start">
                          <Link
                            className="link-text"
                            to={`/eventmaster/market/${item?.id}`}
                          >
                            {item?.name}
                          </Link>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="col-md-6 col-lg-4 ">
          <div className="card_desmond">
            <div className="card-header">
              <h4 className="card-title">Soccer</h4>
            </div>
            <div className="table-responsive ">
              <table className="report-card-box">
                <tbody>
                  {dashboardCount?.matches
                    ?.filter((item) => item?.sport?.id == 1)
                    ?.map((item) => (
                      <tr key={item?._id} className="">
                        <td className="text-start">
                          <Link
                            className="link-text"
                            to={`/eventmaster/market/${item?.id}`}
                          >
                            {item?.name}
                          </Link>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="col-md-6 col-lg-4 ">
          <div className="card_desmond ">
            <div className="card-header">
              <h4 className="card-title">Tennis</h4>
            </div>

            <div className="table-responsive ">
              <table className="report-card-box">
                <tbody>
                  {dashboardCount?.matches
                    ?.filter((item) => item?.sport?.id == 2)
                    ?.map((item) => (
                      <tr key={item?._id} className="">
                        <td className="text-start">
                          <Link
                            className="link-text"
                            to={`/eventmaster/market/${item?.id}`}
                          >
                            {item?.name}
                          </Link>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
